import axios from "axios";
import { redirect } from "next/navigation";

const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
  timeout: 10000,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => {
    console.log(`[Response] ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error("[Response Error]", error);
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access");
      return redirect("/sign-in");
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
